<div *ngIf="article">
  <div class="w-100 d-flex scroll-view">
    <div class="left-part position-relative">
      <app-metadata
        [documentType]="'article'"
        [source]="article.source"
        [territories]="article.territories"
        [publicationDate]="article.publicationDate"
      ></app-metadata>
      <app-welcome-panel [shareToken]="shareToken"></app-welcome-panel>
    </div>

    <div class="right-part overflow-auto">
      <div [ngClass]="{ 'load-position': show }">
        <app-loader
          [show]="show"
          [inView]="true"
          [inSearch]="inSearch"
          [noResult]="searchNotFound"
          [topChoice]="'top-loader-article'"
        ></app-loader>

        <div class="view-content">
          <span class="article-title line-clamp">{{ article.title | uppercase }}</span>
          <div class="search-bar-container" [ngClass]="{ 'sticky-position': !show }">
            <app-control-f
              (onPrev)="controlFService.goToSelected($event)"
              (onNext)="controlFService.goToSelected($event)"
              (onSearch)="article.text && controlFService.prev_find($event, articleGuestViewElement, article.text)"
              [totalMatches]="controlFService.totalMatches"
              [documentLoaded]="true"
            >
            </app-control-f>
          </div>
          <app-image-carousel-smart *ngIf="article" [article]="article" [guestDisplay]="true"></app-image-carousel-smart>
          <div
            class="text text-justify"
            data-cy="guest-article-text"
            [innerHTML]="article.text ? (article.text | highlight: controlFService.inputSearch) : ''"
            #articleGuestView
          ></div>
          <div class="ID-article-0CtgAin" *ngIf="documentProviderId?.length && documentProviderId.length > 0">
            ID article : {{ documentProviderId }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
